var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignComputerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C1D16E22-E62C-4B2A-BD02-FB36B3D22B2F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Campaign_06.1",
    transform: "translate(-689.000000, -578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(328.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-of-Measurements",
    transform: "translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(346.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox-Copy-2",
    transform: "translate(15.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8056266,12.2352941 L18.0051151,12.2352941 L18.0051151,2.82352941 C18.0051151,2.303732 17.6020569,1.88235294 17.1048593,1.88235294 L4.50127877,1.88235294 C4.00408125,1.88235294 3.60102302,2.303732 3.60102302,2.82352941 L3.60102302,12.2352941 L1.80051151,12.2352941 L1.80051151,2.82352941 C1.80051151,1.26413718 3.0096862,-8.3593263e-16 4.50127877,-8.3593263e-16 L17.1048593,-8.3593263e-16 C18.5964519,-8.3593263e-16 19.8056266,1.26413718 19.8056266,2.82352941 L19.8056266,12.2352941 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 10.8030691,
    cy: 4.70588235,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6061381,14.1176471 C21.6061381,16.1968367 19.9939052,17.8823529 18.0051151,17.8823529 L3.60102302,17.8823529 C1.61223292,17.8823529 0,16.1968367 0,14.1176471 L21.6061381,14.1176471 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignComputerIcon);
export default __webpack_public_path__ + "static/media/CampaignComputerIcon.d11eba42d4eefcac506660aede493602.svg";
export { ForwardRef as ReactComponent };